import React from 'react'
import styles from "./Considerations.module.css";
function ConsiderationItem({icon, header, points}) {
  return (
    <div className={styles.ConsiderationItem}>
        {icon && <div className={styles.Icon}>{icon}</div>}
        <div className={styles.ConsiderationContent}>
            <div className={styles.ConsiderationHeader}>{header}</div>
            {points && (
              <ul className={styles.ConsiderationPoints}>
                {points.map((point, index) => (
                  <li key={index}>{point}</li>
                ))}
              </ul>
            )}
        </div>
    </div>
  )
}

export default ConsiderationItem